import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { InputField } from '../../inputField';

const modalStyle = {
  width: '500px',
  height: '240px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class TeapplixResync extends Component {
  state = {
    PONum: '',
  }
  componentDidMount() {
  }

  handleResyncClick = () => {
    const success = () => {
      this.props.setModalVisibility();
    }
    this.props.resyncTeapplix(this.state.PONum, success);
  }

  render() {
    return (
      <form style={styles.container}>
        <h4>Teapplix Resync With CPO Number</h4>
        <div>
          <input
            type="text"
            style={{
              width: '200px',
              border: '1px solid black',
              padding: '2px',
              borderRadius: '5px',
              marginBottom: '10px',
            }}
            onChange={({ target }) => this.setState({
              PONum: target.value
            })}
            value={this.state.location}
            ref="CPOInput"
            autoFocus
          />
        </div>
        <div style={styles.buttonToolbar}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              // this.props.applyAndSave();
              this.props.setModalVisibility();
            }}
          >
            <Translate value="close" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.handleResyncClick()
            }}
          >
            {/* <em className="fa fa-pencil" /> */}
            <Translate value="resync" />
          </Button>
        </div>
      </form>
    )
  }
}

const TeapplixResyncModal = ({ isVisible, setModalVisibility, resyncTeapplix }) => (
  <SkyLightStateless
    title={'Teapplix Resync'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <TeapplixResync setModalVisibility={setModalVisibility} resyncTeapplix={resyncTeapplix} />
  </SkyLightStateless>
)

TeapplixResyncModal.propTypes = propTypes
TeapplixResyncModal.defaultProps = defaultProps

export default TeapplixResyncModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/TeapplixResyncModal.jsx